<template>
  <video
    id="amazonIvsVideojs"
    class="video-js vjs-default-skin"
    controls
    autoplay
    playsinline
  ></video>
</template>

<script>
import videojs from 'video.js';

export default {
  name: 'Video',
  props: {
    liveUrl: {
      type: String,
      default: '',
      required: true
    }
  },
  data() {
    return {
      videoSourceLoaded: true
    };
  },
  mounted() {
    const that = this;
    setTimeout(() => {
      let script = document.createElement('script');
      // try load video object
      try {
        script.onload = function () {
          // eslint-disable-next-line no-undef
          registerIVSTech(videojs);

          // TODO: video js setting hold by data
          const playerName = 'amazonIvsVideojs';
          const playerOptions = {
            techOrder: ['AmazonIVS'],
            autoplay: true,
            liveui: true,
            textTrackSettings: false,
            nativeTextTracks: false
          };

          var player = videojs(playerName, playerOptions, () => {
            // TODO: can we validate the video source
            player.src(that.liveUrl);
          });
        };
        script.src =
          'https://player.live-video.net/1.0.0/amazon-ivs-videojs-tech.min.js';
        this.$el.append(script);
      } catch (err) {
        this.videoSourceLoaded = false;
        console.error(err);
      }
    }, 3000);
  }
};
</script>

<style lang="scss" scoped>
#amazonIvsVideojs {
  margin: auto;
  height: 100%;
  max-height: 1200px; /* 幅が1023pxまでで縦長の端末が登場したら、適宜変更する必要あり */
  width: 100%;
  max-width: 1200px;
}
</style>
